import {
  getRoleLabel,
  resolveRoleSelectValue,
  splitRoleSelectOptions,
} from "../../../utils/roleSelectOptions";

export default function PolicyRoleSelectOptions({ roleOptions, storedValue }) {
  const { systemRoleOptions, customRoleOptions } = splitRoleSelectOptions(roleOptions);
  const resolved = resolveRoleSelectValue(roleOptions, storedValue);
  const hasResolved =
    !resolved ||
    roleOptions.some(
      (role) =>
        role.value === resolved ||
        role.value.toLowerCase() === String(resolved).toLowerCase()
    );

  if (!roleOptions.length) {
    return <option value="">Loading roles…</option>;
  }

  return (
    <>
      {!hasResolved && resolved ? (
        <option value={resolved}>{getRoleLabel(roleOptions, resolved)}</option>
      ) : null}
      {systemRoleOptions.length > 0 && (
        <optgroup label="System roles">
          {systemRoleOptions.map((role) => (
            <option key={`sys-${role.id ?? role.value}`} value={role.value}>
              {role.label}
            </option>
          ))}
        </optgroup>
      )}
      {customRoleOptions.length > 0 && (
        <optgroup label="Custom roles">
          {customRoleOptions.map((role) => (
            <option key={`custom-${role.id ?? role.value}`} value={role.value}>
              {role.label}
            </option>
          ))}
        </optgroup>
      )}
    </>
  );
}
